export default "__VITE_PUBLIC_ASSET__11bee78e__"